import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#adult-guest_svg__clip0_1679_5820)", fill: "#333" }, /* @__PURE__ */ e.createElement("path", { d: "M7.5 8.502a5.51 5.51 0 00-5.5 5.5v3.5a.5.5 0 00.5.5h1.81a.25.25 0 01.25.23l.44 5.31a.5.5 0 00.5.459h4a.5.5 0 00.5-.46l.44-5.31a.25.25 0 01.25-.23h1.81a.5.5 0 00.5-.5v-3.5a5.51 5.51 0 00-5.5-5.499zM7.497 7a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" })),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "adult-guest_svg__clip0_1679_5820" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h16v24H0z" })))
);
export {
  t as default
};
